// extracted by mini-css-extract-plugin
module.exports = {"root":"Selectors_root__-u1oo"};